import React from 'react';
import { PlaylistCard } from '@components/Playlists/basics/PlaylistCard';
import { CarouselWithHeader } from '@components/main-components/carousel/HeaderCarousel';
import {
  type FragmentType,
  getFragment,
  MoreFromArtistCarouselInfoFragmentDoc,
} from '@graphql/reactQuery';
import { useSongAppearsOn } from '@hooks/useSongAppearsOn';
import { GRID_CAROUSEL_INITIAL_PAGE } from '@utils/constants';

export const DiscoveredOnCarousel = ({
  artistFrag,
  releaseId,
  titleSlug,
}: {
  artistFrag: FragmentType<MoreFromArtistCarouselInfoFragmentDoc>;
  releaseId: string;
  titleSlug: string;
}) => {
  const { user } = getFragment(MoreFromArtistCarouselInfoFragmentDoc, artistFrag);

  const { playlists, loadMore } = useSongAppearsOn({
    releaseId,
    initialPageSize: GRID_CAROUSEL_INITIAL_PAGE,
  });

  const playlistSlides = React.useMemo(() => {
    return playlists?.map(playlist => ({
      id: playlist.id,
      slide: <PlaylistCard data={playlist} showMetadata />,
    }));
  }, [playlists]);

  if (!playlistSlides || playlistSlides.length === 0) {
    return null;
  }

  return (
    <div className="relative mx-auto w-full overflow-hidden">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <CarouselWithHeader
          user={user}
          header="Discovered on"
          subheader={null}
          slides={playlistSlides}
          path={`/${titleSlug}/discovered-on`}
          loadMore={loadMore}
          seeAllParams={null}
        />
      </div>
    </div>
  );
};
